import styled from 'styled-components'
import * as zero from '@zero/design-tokens/build/js/variables'
import UHCPriceTotal from '@/components/Cloud/Atoms/Server/Contract/Sidebar/PriceTotal/PriceTotal'
import { Breakpoints } from '@/shared/styles/breakpoints'

export const SidebarButtonFooter = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
`
export const PriceTotalFooter = styled.div`
     font-size: ${zero.ZrFontSizeXs};
     font-family: ${zero.ZrFontFamilyDigitalLight};
     color: ${zero.ZrColorNeutralMedium02};
`

export const StyledUHCPriceTotal = styled(UHCPriceTotal)`
  .price-total {
    font-size: ${zero.ZrFontSizeMd};
    font-weight: 600;    
    
    @media (max-width: ${Breakpoints.menu}) {
      font-size: ${zero.ZrFontSizeSm};
    }
  }
`